import { useState, useEffect } from "react";

/**
 *  A custom hook to handle localStorage
 * @param {*} storageKey - the key to use in localStorage
 * @param {*} fallbackState - the fallback state if no value is stored
 * @returns {[any, function]} - An array with the current value and a function to update it
 */
const useLocalStorage = (storageKey, fallbackState) => {
    const [value, setValue] = useState(() => {
        const stored = localStorage.getItem(storageKey);

        if (stored === null) {
            return fallbackState; // No value stored, return fallbackState
        }

        try {
            return JSON.parse(stored); // Try parsing the stored value
        } catch (error) {
            console.error("Error parsing JSON from localStorage", error);
            return fallbackState; // If parsing fails, return fallbackState
        }
    });

    useEffect(() => {
        // Only set value in localStorage if it's not undefined
        if (value !== undefined) {
            localStorage.setItem(storageKey, JSON.stringify(value));
        }
    }, [value, storageKey]);

    return [value, setValue];
};

export default useLocalStorage;
